import React from 'react'
import './Hero.css'
import Header from '../Header/Header'
import hero_image from '../../assets/hero_image.png';
import hero_image_back from '../../assets/hero_image_back.png';
import heart from '../../assets/heart.png';
import Calories from '../../assets/calories.png';
import {motion} from 'framer-motion'
import NumberCounter from 'number-counter'

const Hero = () => {

    const transition = {type: 'spring' , duration : 3}
    const mobile = window.innerWidth <= 768 ? true:false
  return (
   <div className="hero" id='home'>
    <div className="blur hero-blur"></div>
        <div className="left-h">
            <Header/>
{/*The best add*/}
            <div className="the-best-add">
                <motion.div
                    initial = {{left : mobile? '160px' :'238px'}}
                    whileInView = {{left : '8px'}}
                    transition={{...transition , type : 'tween'}}
                ></motion.div>
                <span>THE BEST FITNESS CLUB IN THE TOWN</span>
            </div>
{/*Hero Heading */}
            <div className="hero-txt">
                <div>
                    <span className='stroke-txt'>shape </span>
                    <span>your</span>
                </div>
                <div>
                    <span>ideal body</span>
                </div>
                <div>
                    <span>In here we will help you to shape and build your ideal body and live up your life to the fullest</span>
                </div>
            </div>
{/*Figures*/}
            <div className="figures">
                <div>
                    <span>
                        <NumberCounter end ={140} start = {100} delay = '4' preFix = "+" />
                    </span>
                    <span>EXPERT COACHS</span>
                </div>
                <div>
                    <span>
                        <NumberCounter end ={978} start = {600} delay = '4' preFix = "+" />
                    </span>
                    <span>MEMBER JOINED</span>
                </div>
                <div>
                    <span>
                    <NumberCounter end ={50} start = {20} delay = '4' preFix = "+" />
                    </span>
                    <span>FITNESS PROGRAMS</span>
                </div>
            </div>
{/*Hero Button*/}
            <div className="hero-button">
                <button className="btn">Get Started</button>
                <button className="btn">Learn More</button>
            </div>
        </div>
        
        <div className="right-h">
        <button className='btn'>JOIN NOW</button>

        <motion.div 
            initial = {{right : '-1rem'}}
            whileInView={{right : '4rem'}}
            transition={transition}
            className="heart-rate">
            <img src={heart} alt="Heart Icon" />
            <span>Heart Rate</span>
            <span>116 bpm</span>
        </motion.div>
{/*Hero Images*/}
        <img src={hero_image} alt="" className='hero-image'/>
        <motion.img 
            initial = {{right : '11rem'}}
            whileInView={{right : '20rem'}}
            transition={transition} 
            src={hero_image_back} alt="" className='hero-image-back'/>
{/*Calories */}
        <motion.div 
            initial = {{right : '37rem'}}
            whileInView={{right : '28rem'}}
            transition={ transition}
            className="calories">
            <img src={Calories} alt="" />
            <div>
                <span>CaloriesBurned</span>
                <span>220kcal</span>  
            </div>
        </motion.div>  
      </div>
    </div>
  );
}

export default Hero